var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaDebitV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 73,
    viewBox: "0 0 180 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.439 55.6886H48.9022L41.0009 24.6578C40.6259 23.2304 39.8296 21.9684 38.6583 21.3737C35.7351 19.879 32.514 18.6895 29 18.0896V16.8949H45.9739C48.3166 16.8949 50.0735 18.6895 50.3664 20.7737L54.466 43.1573L64.9976 16.8949H75.2416L59.439 55.6886ZM81.096 55.6886H71.1449L79.339 16.8949H89.2901L81.096 55.6886ZM102.168 27.6417C102.461 25.5523 104.218 24.3576 106.268 24.3576C109.489 24.0577 112.998 24.6576 115.926 26.1471L117.683 17.7946C114.755 16.5999 111.534 16 108.61 16C98.9522 16 91.9243 21.3735 91.9243 28.8313C91.9243 34.5047 96.9024 37.4837 100.416 39.2783C104.218 41.0678 105.682 42.2625 105.389 44.0519C105.389 46.7361 102.461 47.9308 99.5378 47.9308C96.0239 47.9308 92.5099 47.036 89.2939 45.5414L87.5369 53.899C91.0509 55.3885 94.8526 55.9884 98.3665 55.9884C109.196 56.2832 115.926 50.9149 115.926 42.8572C115.926 32.7101 102.168 32.1154 102.168 27.6417ZM150.753 55.6886L142.851 16.8949H134.364C132.607 16.8949 130.85 18.0896 130.265 19.879L115.634 55.6886H125.877L127.922 50.0203H140.509L141.68 55.6886H150.753ZM135.826 27.3423L138.75 41.963H130.555L135.826 27.3423Z",
    fill: "#172B85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 61.7224V72.136C114.692 72.2137 115.494 72.2604 116.487 72.2604C118.547 72.2604 120.183 71.7256 121.189 70.7351C122.163 69.7593 122.715 68.3442 122.715 66.6147C122.715 64.8995 122.163 63.6723 121.204 62.8085C120.277 61.9591 118.876 61.4875 116.911 61.4875C115.825 61.4875 114.835 61.5814 114 61.7224ZM115.37 71.0967V62.7129C115.731 62.6351 116.266 62.5718 116.973 62.5718C119.868 62.5718 121.283 64.1604 121.267 66.6617C121.267 69.5243 119.694 71.1598 116.752 71.1598C116.219 71.1598 115.715 71.1437 115.37 71.0967Z",
    fill: "url(#paint0_linear_17759_80071)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.336 68.4856C124.336 70.7827 125.735 72.3405 128.079 72.3405C129.29 72.3405 130.139 72.073 130.627 71.8525L130.376 70.8623C129.872 71.081 129.259 71.2544 128.269 71.2544C126.868 71.2544 125.688 70.4845 125.657 68.6122H131.005C131.035 68.4549 131.052 68.2507 131.052 67.9669C131.052 66.5682 130.407 64.3976 127.905 64.3976C125.688 64.3976 124.336 66.1904 124.336 68.4856ZM127.795 65.388C129.353 65.388 129.731 66.756 129.714 67.6218H125.672C125.782 66.6621 126.38 65.388 127.795 65.388Z",
    fill: "url(#paint1_linear_17759_80071)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.163 61V70.2008C133.163 70.8767 133.132 71.6483 133.102 72.1672H134.28L134.359 70.9236H134.39C134.972 71.9156 135.854 72.3405 136.955 72.3405C138.653 72.3405 140.383 70.987 140.383 68.2669C140.383 65.9698 139.062 64.3976 137.159 64.3976C135.932 64.3976 135.052 64.9325 134.563 65.782H134.533V61H133.163ZM134.594 69.6189C134.547 69.4616 134.533 69.2881 134.533 69.1164V67.7627C134.533 67.5422 134.563 67.3544 134.61 67.1807C134.894 66.1435 135.774 65.482 136.703 65.482C138.196 65.482 138.982 66.7886 138.982 68.3138C138.982 70.0597 138.135 71.2399 136.671 71.2399C135.664 71.2399 134.847 70.5784 134.594 69.6189Z",
    fill: "url(#paint2_linear_17759_80071)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.336 62.4154C142.336 62.8872 142.665 63.2649 143.169 63.2649C143.718 63.2649 144.049 62.8872 144.049 62.4154C144.049 61.9276 143.704 61.5498 143.2 61.5498C142.681 61.5498 142.336 61.9439 142.336 62.4154ZM142.508 72.1676H143.892V64.5553H142.508V72.1676Z",
    fill: "url(#paint3_linear_17759_80071)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.897 63.138V64.5549H145.719V65.6085H146.897V69.7597C146.897 70.6563 147.054 71.3339 147.432 71.7586C147.763 72.1201 148.281 72.3405 148.927 72.3405C149.461 72.3405 149.886 72.2464 150.154 72.1508L150.09 71.0972C149.886 71.1603 149.666 71.1911 149.288 71.1911C148.518 71.1911 148.251 70.6563 148.251 69.7128V65.6085H150.232V64.5549H148.251V62.7296L146.897 63.138Z",
    fill: "url(#paint4_linear_17759_80071)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17759_80071",
    x1: 114,
    y1: 66.6702,
    x2: 150.231,
    y2: 66.6702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0540673,
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360259,
    stopColor: "#262B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683381,
    stopColor: "#1E3D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17759_80071",
    x1: 114,
    y1: 66.6702,
    x2: 150.232,
    y2: 66.6702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0540673,
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360259,
    stopColor: "#262B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683381,
    stopColor: "#1E3D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17759_80071",
    x1: 114,
    y1: 66.6702,
    x2: 150.232,
    y2: 66.6702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0540673,
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360259,
    stopColor: "#262B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683381,
    stopColor: "#1E3D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17759_80071",
    x1: 114.001,
    y1: 66.6703,
    x2: 150.231,
    y2: 66.6703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0540673,
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360259,
    stopColor: "#262B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683381,
    stopColor: "#1E3D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17759_80071",
    x1: 145.719,
    y1: 67.5354,
    x2: 150.232,
    y2: 67.5354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0540673,
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360259,
    stopColor: "#262B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683381,
    stopColor: "#1E3D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaDebitV2);
export default __webpack_public_path__ + "static/media/visa-debit-v2.e6325ef19fa4ea8d7db90cd5566fbcc5.svg";
export { ForwardRef as ReactComponent };